import type { CityConfig } from "../city-template/types";

export const evanstonConfig: CityConfig = {
  city: "Evanston",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "evanston",
  route: "/cities/evanston",
  title: "Emergency Passport Evanston, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Evanston, Illinois — as fast as 24 hours. Fast passport renewal and new passport applications for Northwestern University faculty, North Shore families, and all Cook County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Evanston, IL",
  heroSubtitle: "Northwestern University professor with a conference in Geneva next week? North Shore family vacation to Italy and your passport expired? Lakefront business trip to Tokyo with 5 days notice? We help Evanston residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving the North Shore.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Evanston%20Illinois%20North%20Shore%20cityscape%20featuring%20Northwestern%20University%20campus%20with%20ivy%20covered%20academic%20buildings%2C%20Lake%20Michigan%20shoreline%20with%20lighthouse%2C%20historic%20downtown%20Evanston%20Davis%20Street%20commercial%20district%2C%20tree-lined%20streets%20with%20classic%20North%20Shore%20architecture%2C%20golden%20hour%20warm%20light%20over%20lake%2C%20professional%20urban%20photography%2C%20affluent%20Chicago%20suburb%20atmosphere&width=1800&height=700&seq=evanston-hero-001&orientation=landscape",
  heroImageAlt: "Evanston Illinois North Shore with Northwestern University campus and Lake Michigan shoreline",
  geoPosition: "42.0451;-87.6877",
  geoPlacename: "Evanston, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 25 minutes south of Evanston via Lake Shore Drive or I-94",
  },
  nearbyCitiesZips: [
    { name: "Evanston", zips: "60201, 60202, 60203, 60208" },
    { name: "Skokie", zips: "60076, 60077" },
    { name: "Wilmette", zips: "60091" },
    { name: "Winnetka", zips: "60093" },
    { name: "Glenview", zips: "60025, 60026" },
    { name: "Glencoe", zips: "60022" },
    { name: "Highland Park", zips: "60035" },
    { name: "Northbrook", zips: "60062" },
    { name: "Lincolnwood", zips: "60712" },
    { name: "Morton Grove", zips: "60053" },
    { name: "Niles", zips: "60714" },
    { name: "Deerfield", zips: "60015" },
    { name: "Highwood", zips: "60040" },
    { name: "Lake Forest", zips: "60045" },
    { name: "Kenilworth", zips: "60043" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 25 minutes away but you skip the trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-graduation-cap-line", title: "Academic Travel Hub", desc: "Serving Northwestern University faculty, researchers, and international students" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no downtown Chicago trip required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Waukegan, IL", route: "/cities/waukegan" },
    { name: "Emergency passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Urgent passport services in Highland Park, IL", route: "/states/illinois" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Evanston, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (25 minutes south via Lake Shore Drive) — without you making the trip. Evanston residents can ship from any UPS or FedEx on the North Shore.",
  fpcOfficeDistance: "Serving Evanston, Skokie, Wilmette, Winnetka, Glenview, Glencoe, Highland Park, Northbrook, Lincolnwood, Morton Grove, Niles, Deerfield, Highwood, Lake Forest, and all of the North Shore",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Evanston and Chicago's North Shore. From the Northwestern University campus and downtown Evanston's Davis Street corridor to the lakefront mansions of Sheridan Road and the family neighborhoods of Central Street, from the bustling retail of Skokie to the tree-lined streets of Wilmette — we serve all of the North Shore and beyond.",
  nearbyCitiesIntro: "We serve Evanston and all nearby communities including Skokie, Wilmette, Winnetka, Glenview, Glencoe, Highland Park, Northbrook, Lincolnwood, Morton Grove, Niles, Deerfield, Kenilworth, Highwood, and Lake Forest. We also serve all North Shore communities and northern Cook County.",
  howItWorksIntro: "Most Evanston travelers complete everything online and ship documents overnight. No need to drive 25 minutes to downtown Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Evanston is home to Northwestern University with massive international travel needs and an affluent North Shore community with year-round vacation travel. Here are the most common passport mistakes we see from Evanston and North Shore travelers.",
  testimonialsIntro: "Evanston travelers — from Northwestern professors and international researchers to North Shore families and business professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Evanston, IL? Here are the most common ones we hear from North Shore travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No drive to downtown Chicago required", "Perfect for academic conferences and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 25 minutes to downtown Chicago", "Downtown parking, navigation, and time commitment"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Evanston travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — just 25 minutes away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "North Shore academic and corporate travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Evanston adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Evanston address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Evanston residents — including Northwestern international students, new citizens, and North Shore families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Evanston residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Evanston and North Shore families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Evanston and North Shore residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Evanston IL", description: "Urgent passport processing for Evanston Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Evanston IL", description: "Fast passport renewal for Evanston Illinois residents with a previously-issued passport." },
    { name: "First-Time Passport Evanston IL", description: "New passport application services for Evanston Illinois residents applying for their first passport." },
    { name: "Child Passport Evanston IL", description: "Minor passport services for Evanston Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Sarah W.",
      location: "Evanston, IL",
      rating: 5,
      text: "Northwestern conference in Berlin with 5 days notice and my passport was expired. Fast Passport Center had my renewal in 28 hours. I shipped from the UPS on Sherman Avenue between classes. The dedicated agent was phenomenal — understood academic travel urgency perfectly.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Michael T.",
      location: "Wilmette, IL",
      rating: 5,
      text: "Three passports for a family trip to Australia — two adult renewals and a first-time for our son. Fast Passport Center got all three done in 4 days. We shipped from FedEx on Green Bay Road. Incredible service for North Shore families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Rebecca K.",
      location: "Evanston, IL",
      rating: 5,
      text: "International business trip to Singapore with 8 days notice. Fast Passport Center handled everything. My new passport arrived in 3 days. As a downtown Evanston professional, not having to drive to the Chicago agency was worth every penny.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "evn-1",
      name: "Evanston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1101 Davis St",
      city: "Evanston",
      state: "IL",
      zip: "60201",
      phone: "(847) 328-2525",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Evanston, Davis Street corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Evanston acceptance facility. Appointments required — book 1–2 weeks in advance. Walking distance to Northwestern University and downtown Evanston.",
      icon: "ri-mail-line",
    },
    {
      id: "evn-2",
      name: "Skokie Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4950 Madison St",
      city: "Skokie",
      state: "IL",
      zip: "60077",
      phone: "(847) 676-0070",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Skokie, approximately 5 miles west of Evanston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Skokie, Lincolnwood, and western Evanston. Near Old Orchard shopping area.",
      icon: "ri-mail-line",
    },
    {
      id: "evn-3",
      name: "Wilmette Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1241 Central Ave",
      city: "Wilmette",
      state: "IL",
      zip: "60091",
      phone: "(847) 251-2311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Wilmette, approximately 3 miles north of Evanston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Wilmette, Kenilworth, and northern Evanston residents. Near downtown Wilmette.",
      icon: "ri-mail-line",
    },
    {
      id: "evn-4",
      name: "Cook County Clerk — Skokie",
      type: "County Clerk Passport Acceptance",
      address: "5600 Old Orchard Rd, Room 149",
      city: "Skokie",
      state: "IL",
      zip: "60077",
      phone: "(312) 603-5656",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Skokie, Cook County Satellite Office",
      website: "https://www.cookcountyclerk.com/",
      websiteLabel: "Cook County Clerk",
      notes: "Cook County Clerk satellite passport acceptance. Serves North Shore communities. Call ahead to confirm hours.",
      icon: "ri-government-line",
    },
    {
      id: "evn-5",
      name: "Glenview Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1400 Patriot Blvd",
      city: "Glenview",
      state: "IL",
      zip: "60026",
      phone: "(847) 998-0112",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Glenview, approximately 8 miles west of Evanston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Glenview, Northbrook, and western North Shore communities.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25 min drive to downtown Chicago", fpc: "No — ship from Evanston" },
    { feature: "Parking & Navigation", agency: "Downtown Chicago parking costs", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Academic Travel Deadlines",
      description: "Northwestern faculty and researchers often discover expired passports right before international conferences. The Chicago Passport Agency is close but appointments fill weeks out during academic travel seasons.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near campus sometimes produce photos that meet ID but fail passport standards. Photos must be exactly 2x2 inches on a white background with no shadows.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or incorrect form type cause rejections at Evanston and Skokie acceptance facilities. International students on visas need special documentation — verify before your appointment.",
    },
    {
      icon: "ri-global-line",
      title: "Visa Confusion for International Travel",
      description: "International researchers and students from Northwestern often confuse passport renewal with visa renewal. Your passport must be valid for at least 6 months past your return date regardless of visa status.",
    },
    {
      icon: "ri-road-map-line",
      title: "Driving to Chicago Agency Unnecessarily",
      description: "Evanston is only 25 minutes from the Chicago Passport Agency, but even a short trip means downtown parking and navigation headaches. Our courier service makes the trip for you.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent for Minors",
      description: "Both parents must appear or submit notarized consent for child passports. North Shore families often arrive at acceptance facilities with only one parent present — causing delays.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Evanston area or North Shore." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near downtown Evanston or Sherman Avenue." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — experienced with academic, corporate, and family travel documentation." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 25 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Evanston address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Evanston, IL?", a: "Fast Passport Center offers emergency passport processing in Evanston, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (25 minutes south via Lake Shore Drive) — without you making the trip." },
    { q: "Does Evanston have its own passport agency?", a: "No — Evanston does not have a regional passport agency. The nearest facility is the Chicago Passport Agency (approximately 25 minutes south via Lake Shore Drive or I-94). Fast Passport Center's courier service means Evanston residents never need to make the trip." },
    { q: "Can I get an expedited passport in Skokie, Wilmette, or Winnetka?", a: "Absolutely. Fast Passport Center serves all of Chicago's North Shore including Skokie, Wilmette, Winnetka, Glenview, Glencoe, Highland Park, Northbrook, and all northern Cook County communities. Our service works the same way everywhere." },
    { q: "Does Fast Passport Center serve Northwestern University?", a: "Yes. Fast Passport Center serves Northwestern University faculty, staff, researchers, and students. We understand academic conference schedules, research travel deadlines, and international student visa requirements. Our service is ideal for busy academics who can't spend a day at the Chicago Passport Agency." },
    { q: "What airport do Evanston travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is the primary airport for Evanston and North Shore travelers. O'Hare is approximately 25 minutes west via I-94 and I-90 and offers direct international flights worldwide. Chicago Midway (MDW) is approximately 45 minutes south." },
    { q: "Where can I get passport photos in Evanston?", a: "Walgreens, CVS, and UPS Store locations throughout Evanston and Skokie offer passport photos. FedEx Office also provides them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Can I get a passport for my child in Evanston?", a: "Yes. Fast Passport Center provides child passport services for minors under 16 throughout Evanston and the North Shore. Both parents or legal guardians must typically be present at the acceptance facility, and we guide you through the entire process." },
    { q: "How much does an expedited passport cost in Evanston, IL?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
  ],
  photoLocations: [
    { name: "Walgreens — Evanston Downtown", address: "2101 Sherman Ave, Evanston, IL 60201", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Evanston", address: "1710 Sherman Ave, Evanston, IL 60201", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "CVS — Evanston", address: "101 Asbury Ave, Evanston, IL 60202", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "FedEx Office — Skokie", address: "4925 Old Orchard Center, Skokie, IL 60077", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Evanston", address: "1840 Oak Ave, Evanston, IL 60201", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Convenient to downtown Evanston and Northwestern University. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Niles", address: "8920 N Greenwood Ave, Niles, IL 60714", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Skokie, Niles, and western Evanston area. Full REAL ID processing available.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Cook County birth and death certificates" },
    { label: "Marriage Licenses (Cook County Clerk)", url: "https://www.cookcountyclerk.com/service/marriage-licenses", desc: "Cook County Clerk — marriage license applications and certified copies for Evanston and North Shore" },
    { label: "Divorce Decrees (Cook County Circuit Clerk)", url: "https://www.cookcountyclerkofcourt.org/", desc: "Cook County Circuit Clerk — divorce decree records for Evanston and Cook County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 25 minutes west via I-94 and I-90",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Evanston and the North Shore. One of the world's busiest airports with direct flights to Europe, Asia, and the Americas. United and American Airlines hub.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 45 minutes south via I-94 and I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub with domestic connections. Good for travelers flying Southwest to connect to international destinations.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};